import { ScreenSize } from '../constant/ScreenSize';

export function measureScreenSize(screenWidth: number) {
  if (screenWidth >= ScreenSize.MaxContent) {
    return ScreenSize.MaxContent;
  }
  if (screenWidth >= ScreenSize.ThreeColumn) {
    return ScreenSize.ThreeColumn;
  }
  if (screenWidth >= ScreenSize.AutoSidebar) {
    return ScreenSize.AutoSidebar;
  }
  if (screenWidth >= ScreenSize.OnlySidebar) {
    return ScreenSize.OnlySidebar;
  }
  if (screenWidth >= ScreenSize.Mobile) {
    return ScreenSize.Mobile;
  }
  return undefined;
}
